import { IonCol, IonGrid, IonModal, IonRow } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { graphGaitAndStepLengthNormValue } from "../../utils/sharedFunction";
import GraphAssessmentDescriptionModal from "../modals/graph-assessment-description";
import { get } from "http";
import { op } from "@tensorflow/tfjs-core";
interface Props {
  options: option;
}
interface option {
  graphName: String;
  graphSVG: React.ReactNode;
  graphTitle: String;
  graphTitleDesc: String;
  graphNormValue: number;
  isgraphNorm: Boolean;
  graphActualValue: Number[];
  graphActualValueLabel: string[];
  graphRange: number[];
  graphRangeLabel: String[];
  graphNoLines: String[];
  minMax: Boolean;
  graphUnit: String;
  graphAge: number;
}
const CustomBarGraph: React.FC<Props> = ({ options }) => {
  console.log("CustomBarGraph options: ", options);
  console.log(
    `[${options.graphName}] Actual Values: `,
    options.graphActualValue,
  );
  console.log(
    `[${options.graphName}] Age: ${options.graphAge}, Range: [${options.graphRange}], Unit: ${options.graphUnit}`,
  );
  const checkNormWithAge = () => {
    let value: number = 0;
    if (options.graphName == "GaitSpeed") {
      if (options.graphAge >= 6 && options.graphAge <= 12) value = 1.13;
      else if (options.graphAge >= 13 && options.graphAge <= 19) value = 1.22;
      else if (options.graphAge >= 20 && options.graphAge <= 69) value = 1.32;
      else if (options.graphAge >= 70 && options.graphAge <= 74) value = 1.16;
      else if (options.graphAge >= 75 && options.graphAge <= 79) value = 1.12;
      else if (options.graphAge >= 80 && options.graphAge <= 84) value = 1.01;
      else if (options.graphAge >= 85) value = 0.98;
    } else if (options.graphName == "StepsLength") {
      if (options.graphAge >= 6 && options.graphAge <= 12)
        value = Math.floor(0.58 * 100);
      else if (options.graphAge >= 13 && options.graphAge <= 19)
        value = Math.floor(0.68 * 100);
      else if (options.graphAge >= 20 && options.graphAge <= 69)
        value = Math.floor(0.66 * 100);
      else if (options.graphAge >= 70 && options.graphAge <= 74)
        value = Math.floor(0.61 * 100);
      else if (options.graphAge >= 75 && options.graphAge <= 79)
        value = Math.floor(0.59 * 100);
      else if (options.graphAge >= 80 && options.graphAge <= 84)
        value = Math.floor(0.55 * 100);
      else if (options.graphAge >= 85) value = Math.floor(0.54 * 100);
    }
    return value;
  };
  const [norm, setNorm] = useState(checkNormWithAge());
  const checkNormWithAgeCssWidth = () => {
    if (options.graphName == "GaitSpeed") {
      if (options.graphAge >= 6 && options.graphAge <= 12)
        return Math.floor(1.13 * 66.666);
      else if (options.graphAge >= 13 && options.graphAge <= 19)
        return Math.floor(1.22 * 66.666);
      else if (options.graphAge >= 20 && options.graphAge <= 69)
        return Math.floor(1.32 * 66.666);
      else if (options.graphAge >= 70 && options.graphAge <= 74)
        return Math.floor(1.16 * 66.666);
      else if (options.graphAge >= 75 && options.graphAge <= 79)
        return Math.floor(1.12 * 66.666);
      else if (options.graphAge >= 80 && options.graphAge <= 84)
        return Math.floor(1.01 * 66.666);
      else if (options.graphAge >= 85) return Math.floor(0.98 * 66.666);
    } else if (options.graphName == "StepsLength") {
      if (options.graphAge >= 6 && options.graphAge <= 12)
        return Math.floor(0.58 * 100);
      else if (options.graphAge >= 13 && options.graphAge <= 19)
        return Math.floor(0.68 * 100);
      else if (options.graphAge >= 20 && options.graphAge <= 69)
        return Math.floor(0.66 * 100);
      else if (options.graphAge >= 70 && options.graphAge <= 74)
        return Math.floor(0.61 * 100);
      else if (options.graphAge >= 75 && options.graphAge <= 79)
        return Math.floor(0.59 * 100);
      else if (options.graphAge >= 80 && options.graphAge <= 84)
        return Math.floor(0.55 * 100);
      else if (options.graphAge >= 85) return Math.floor(0.54 * 100);
    }
  };
  const colorModes = {
    green: "#8ADDA6",
    orange: "#FFB76F",
    red: "#E97B7B",
    blue: "#91CBDC",
  };

  const backgroundBarColorModes = {
    green: "rgba(67, 186, 115, 0.3)",
    orange: "rgba(248, 153, 58, 0.3)",
    red: "rgba(219, 75, 75, 0.3)",
    blue: "rgba(111, 134, 248, 0.3)",
  };
  // const colorModes = {
  //   green: "#12A55E",
  //   orange: "#F8993A",
  //   red: "#D05454",
  //   blue: "#005A75",
  // };
  const getBackgroundBarColor = (value: number) => {
    if (options.graphName == "GaitSpeed") {
      if (norm != undefined) {
        // if (value < norm)
        if (value < 0.7) return backgroundBarColorModes.red;
        // else if (value == norm)
        else if (value >= 0.7 && value <= 1.07)
          return backgroundBarColorModes.orange;
        else if (value > 1.07)
          // else if (value > norm)
          return backgroundBarColorModes.green;
      }
    }
  };
  const getValueColor = (value: number) => {
    if (options.graphName == "FallRisk") {
      if (value < options.graphRange[0]) return colorModes.green;
      else if (value >= options.graphRange[0] && value <= options.graphRange[1])
        return colorModes.orange;
      else if (value > options.graphRange[1]) return colorModes.red;
    } else if (options.graphName == "GaitSpeed") {
      // let norm = checkNormWithAge();
      if (norm != undefined) {
        // if (value < norm)
        if (value < 0.7) return colorModes.red;
        // else if (value == norm)
        else if (value >= 0.7 && value <= 1.07) return colorModes.orange;
        else if (value > 1.07)
          // else if (value > norm)
          return colorModes.green;
      }
    } else if (options.graphName == "StepsLength") {
      // let valueTest = parseInt(value) * 100;
      // let norm = checkNormWithAge();
      if (norm != undefined) {
        if (Number(value) < norm * 100) return colorModes.red;
        else if (Number(value) == norm * 100) return colorModes.orange;
        else if (Number(value) > norm * 100) return colorModes.green;
      }
    } else if (
      options.graphName == "NumbersOfSteps" ||
      options.graphName == "RedLightsMissed" ||
      options.graphName == "AverageSpeed" ||
      options.graphName == "Distance" ||
      options.graphName == "MetersLost"
    ) {
      return colorModes.blue;
    } else if (options.graphName == "TotalTime") {
      console.log("value", value);
      if (value < 8) {
        return colorModes.green;
      } else if (value >= 8.1 && value <= 15) {
        return colorModes.orange;
      } else if (value > 15) {
        return colorModes.red;
      }
    } else if (options.graphName == "TotalTimeTug") {
      const normValue = getNormativeTime(options.graphAge);

      // Green if below norm value (faster is better for TUG)
      if (value < normValue) {
        return colorModes.green;
      }
      // Orange if at or slightly above norm (within 1 second)
      else if (value >= normValue && value <= normValue + 1) {
        return colorModes.orange;
      }
      // Red if significantly above norm
      else {
        return colorModes.red;
      }
    } else if (options.graphName == "TimePerRep") {
      return colorModes.blue;
    } else if (options.graphName == "ForwardReach") {
      const mobility = getForwardReachBarColor(value);

      // Red if below norm value
      if (mobility === "low") {
        return colorModes.red;
      }
      // Yellow/Orange if at or slightly above norm (within 1 inch)
      else if (mobility === "medium") {
        return colorModes.orange;
      }
      // Green if significantly above norm
      else {
        return colorModes.green;
      }
    } else if (options.graphName == "LateralReach") {
      debugger;
      const normValue = getLateralReachNormValue(options.graphAge);

      // Red if below norm value
      if (value < normValue) {
        return colorModes.red;
      }
      // Yellow/Orange if exactly equal to norm value
      else if (value === normValue) {
        return colorModes.orange;
      }
      // Green if above norm value
      else {
        return colorModes.green;
      }
    } else if (options.graphName == "Composite Score") {
      const normValue = getCompositeNormValue(options.graphAge);

      // Red if below norm value
      if (value < normValue) {
        return colorModes.red;
      }
      // Yellow/Orange if equal to norm value
      else if (value === normValue) {
        return colorModes.orange;
      }
      // Green if above norm value
      else {
        return colorModes.green;
      }
    } else if (options.graphName == "Visual Score") {
      const normValue = getVisualNormValue(options.graphAge);

      // Red if below norm value
      if (value < normValue) {
        return colorModes.red;
      }
      // Yellow/Orange if equal to norm value
      else if (value === normValue) {
        return colorModes.orange;
      }
      // Green if above norm value
      else {
        return colorModes.green;
      }
    } else if (options.graphName == "Vestibular Score") {
      const normValue = getVestibularNormValue(options.graphAge);

      // Red if below norm value
      if (value < normValue) {
        return colorModes.red;
      }
      // Yellow/Orange if equal to norm value
      else if (value === normValue) {
        return colorModes.orange;
      }
      // Green if above norm value
      else {
        return colorModes.green;
      }
    } else if (options.graphName == "Somatosensory Score") {
      const normValue = getSomatosensoryNormValue(options.graphAge);

      // Red if below norm value
      if (value < normValue) {
        return colorModes.red;
      }
      // Yellow/Orange if equal to norm value
      else if (value === normValue) {
        return colorModes.orange;
      }
      // Green if above norm value
      else {
        return colorModes.green;
      }
    }

    // Default fallback
    console.warn(
      `[${options.graphName}] No color match found for value: ${value}`,
    );
    return colorModes.blue;
  };
  const getBarWidth = (value: any) => {
    const min = options.graphRange[0];
    const max = options.graphRange[options.graphRange.length - 1];

    // Clamp value so bar doesn't go outside
    console.log("options", options);
    console.log(
      `[${options.graphName}] getBarWidth input value: ${value}, calculated width:`,
      value,
    );
    if (options.graphName == "FallRisk") {
      return value;
    } else if (
      options.graphName == "GaitSpeed" ||
      options.graphName == "AverageSpeed"
    ) {
      return value * 66.666;
    } else if (
      options.graphName == "StepsLength" ||
      options.graphName == "Distance" ||
      options.graphName == "MetersLost"
    ) {
      return value;
    } else if (
      options.graphName == "NumbersOfSteps" ||
      options.graphName == "RedLightsMissed"
    ) {
      return value * 4;
    } else if (options.graphName == "TotalTime") {
      return value * 1.4;
    } else if (options.graphName == "TimePerRep") {
      return value * 4;
    } else if (options.graphName === "TotalTimeTug") {
      return (value / 18) * 100; // Scale value to percentage of max range (18)
    } else if (options.graphName === "ForwardReach") {
      return (value / 16) * 100; // Scale value to percentage of max range (16 inches)
    } else if (options.graphName === "LateralReach") {
      return (value / 40) * 100; // Scale value to percentage of max range (40 inches)
    } else if (options.graphName === "Composite Score") {
      return value; // Value is already a percentage (0-100 range)
    } else if (options.graphName === "Visual Score") {
      return value; // Value is already a percentage (0-100 range)
    } else if (options.graphName === "Vestibular Score") {
      return value; // Value is already a percentage (0-100 range)
    } else if (options.graphName === "Somatosensory Score") {
      return value; // Value is already a percentage (0-100 range)
    }

    // Default fallback
    console.warn(
      `[${options.graphName}] No width calculation match, using value as-is: ${value}`,
    );
    return value;
  };
  const convertValueToPercentage = (level: any) => {
    if (options.graphName === "TotalTimeTug") {
      // Scale the values to fit within 0-18 range
      return (level / 18) * 100; // This will make 16 map to 100%
    } else if (
      options.graphName == "GaitSpeed" ||
      options.graphName == "AverageSpeed"
    ) {
      return level * 66.666;
    } else if (
      options.graphName == "StepsLength" ||
      options.graphName == "FallRisk" ||
      options.graphName == "Distance" ||
      options.graphName == "MetersLost"
    ) {
      return Number(level);
    } else if (
      options.graphName == "NumbersOfSteps" ||
      options.graphName == "RedLightsMissed"
    ) {
      return level * 4;
    } else if (options.graphName == "TotalTime") {
      return level * 1.4;
    } else if (options.graphName == "TimePerRep") {
      return level * 4;
    } else if (options.graphName === "ForwardReach") {
      return (level / 16) * 100;
    } else if (options.graphName === "LateralReach") {
      return (level / 40) * 100;
    } else if (options.graphName === "Composite Score") {
      return level;
    } else if (options.graphName === "Visual Score") {
      return level;
    } else if (options.graphName === "Vestibular Score") {
      return level;
    } else if (options.graphName === "Somatosensory Score") {
      return level;
    }

    // Default fallback
    return Number(level);
  };
  const dataOut = (actualValue: any) => {
    let width = getBarWidth(actualValue);
    if (width < 18) return true;
    else return false;
  };

  const getNormativeTime = (age: number): number => {
    console.log("Calculating normative time for age:", age);
    let time = 0;
    if (age >= 60 && age <= 69) time = 8;
    else if (age >= 70 && age <= 79) time = 9;
    else if (age >= 80 && age <= 89) time = 11;
    else time = 8; // For ages under 60, use 8 seconds as the normative value

    console.log("Calculated normative time:", time);
    return time;
  };

  const getForwardReachNormValue = (age: number): number => {
    console.log("Calculating forward reach norm value for age:", age);
    let value = 0;
    if (age >= 20 && age <= 40) value = 14.6;
    else if (age >= 41 && age <= 59) value = 13.8;
    else if (age >= 60 && age <= 69) value = 13.8;
    else if (age >= 70 && age <= 199) value = 10.4;
    else value = 14.6; // Default for ages under 20

    console.log("Calculated forward reach norm value:", value);
    return value;
  };

  const getForwardReachBarColor = (ForwardReach: number): string => {
    let mobility = "";
    if (ForwardReach < 6) {
      mobility = "low";
    } else if (ForwardReach <= 10 && ForwardReach >= 6) {
      mobility = "medium";
    } else if (ForwardReach > 10) {
      mobility = "high";
    }
    return mobility;
  };
  const getLateralReachNormValue = (age: number): number => {
    console.log("Calculating lateral reach norm value for age:", age);
    let value = 0;
    if (age >= 20 && age <= 29) value = 9.04;
    else if (age >= 30 && age <= 39) value = 9.09;
    else if (age >= 40 && age <= 49) value = 7.46;
    else if (age >= 50 && age <= 59) value = 7.23;
    else if (age >= 60 && age <= 69) value = 6.73;
    else if (age >= 70 && age <= 199) value = 6.18;
    else value = 9.04; // Default for ages under 20

    console.log("Calculated lateral reach norm value:", value);
    return value;
  };

  const getCompositeNormValue = (age: number): number => {
    console.log("Calculating composite norm value for age:", age);
    let value = 0;
    if (age >= 9 && age <= 19) value = 97;
    else if (age >= 19 && age <= 29) value = 94;
    else if (age >= 29 && age <= 39) value = 90;
    else if (age >= 39 && age <= 49) value = 85;
    else if (age >= 49 && age <= 59) value = 81;
    else if (age >= 59 && age <= 69) value = 76;
    else if (age >= 69 && age <= 79) value = 71;
    else if (age >= 79 && age <= 89) value = 67;
    else if (age >= 89 && age <= 99) value = 56;
    else if (age >= 99 && age <= 199) value = 56;
    else value = 97; // Default for ages under 9

    console.log("Calculated composite norm value:", value);
    return value;
  };

  const getVisualNormValue = (age: number): number => {
    console.log("Calculating visual norm value for age:", age);
    let value = 0;
    if (age >= 9 && age <= 19) value = 98;
    else if (age >= 19 && age <= 29) value = 95;
    else if (age >= 29 && age <= 39) value = 90;
    else if (age >= 39 && age <= 49) value = 86;
    else if (age >= 49 && age <= 59) value = 84;
    else if (age >= 59 && age <= 69) value = 78;
    else if (age >= 69 && age <= 79) value = 72;
    else if (age >= 79 && age <= 89) value = 68;
    else if (age >= 89 && age <= 99) value = 62;
    else if (age >= 99 && age <= 199) value = 62;
    else value = 98; // Default for ages under 9

    console.log("Calculated visual norm value:", value);
    return value;
  };

  const getVestibularNormValue = (age: number): number => {
    console.log("Calculating vestibular norm value for age:", age);
    let value = 0;
    if (age >= 9 && age <= 19) value = 95;
    else if (age >= 19 && age <= 29) value = 90;
    else if (age >= 29 && age <= 39) value = 85;
    else if (age >= 39 && age <= 49) value = 76;
    else if (age >= 49 && age <= 59) value = 70;
    else if (age >= 59 && age <= 69) value = 65;
    else if (age >= 69 && age <= 79) value = 60;
    else if (age >= 79 && age <= 89) value = 55;
    else if (age >= 89 && age <= 99) value = 49;
    else if (age >= 99 && age <= 199) value = 49;
    else value = 95; // Default for ages under 9

    console.log("Calculated vestibular norm value:", value);
    return value;
  };

  const getSomatosensoryNormValue = (age: number): number => {
    console.log("Calculating somatosensory norm value for age:", age);
    let value = 0;
    if (age >= 9 && age <= 19) value = 97;
    else if (age >= 19 && age <= 29) value = 93;
    else if (age >= 29 && age <= 39) value = 89;
    else if (age >= 39 && age <= 49) value = 84;
    else if (age >= 49 && age <= 59) value = 79;
    else if (age >= 59 && age <= 69) value = 73;
    else if (age >= 69 && age <= 79) value = 70;
    else if (age >= 79 && age <= 89) value = 65;
    else if (age >= 89 && age <= 99) value = 59;
    else if (age >= 99 && age <= 199) value = 59;
    else value = 97; // Default for ages under 9

    console.log("Calculated somatosensory norm value:", value);
    return value;
  };

  const [GraphAsseDesc, setGraphAsseDesc] = useState(false);
  const [modalData, setModalData] = useState<any>({}); // Initialize modalData
  const handleOpenModal = () => {
    setModalData(createModalData(options.graphName.toString())); // Set modal data when opening modal
    setGraphAsseDesc(true);
  };

  const createModalData = (graphName: string) => {
    let data = {
      setGraphAsseDesc: setGraphAsseDesc,
      title: options.graphTitle,
      icon:
        options.graphSVG && React.isValidElement(options.graphSVG)
          ? React.cloneElement(options.graphSVG as React.ReactElement<any>, {
              width: 100,
              height: 80,
            })
          : null, // Use type assertion
      unit: "",
      description: "",
      measurementDescription: "",
      measurementsList: [] as (string | { main: string; sub: string[] })[],
    };

    const getAROMData = (plane: string, examples: string[]): typeof data => ({
      setGraphAsseDesc: setGraphAsseDesc,
      title: options.graphTitle,
      icon:
        options.graphSVG && React.isValidElement(options.graphSVG)
          ? React.cloneElement(options.graphSVG as React.ReactElement<any>, {
              width: 100,
              height: 80,
            })
          : null, // Use type assertion
      unit: "",
      description: `Data indicates AROM of ${plane}.`,
      measurementDescription:
        "Measured in degrees of motion at the end range where participant unable to achieve further motion without compensation or pain. Differential Diagnosis is required, but limitations in motion may be caused by swelling, pain, weakness, contracture, or injury.",
      measurementsList: examples,
    });

    switch (graphName) {
      case "GaitSpeed":
        data.unit = "(m/s)";
        data.description =
          "Gait speed is the time one takes to walk in relationship to a specific distance and is measured in meters per second. Gait speed is highly correlated to fall risk in the elderly population. The minimal clinically important difference (MCID) of .08 m/s is considered clinically significant for improvement or decline in safety.";
        data.measurementDescription =
          "Measured by meters per second traveled over a constant distance.";
        data.measurementsList = [
          "Gait speed is highly related to fall risk. Falls are one of the leading causes of death or downgrade in lifestyle living.",
          "Research notes that a change in .08 m/s is clinically significant to increase or decrease fall risk of an individuals.",
        ];
        break;

      case "TimePerRep":
        data.description =
          "This chart provides data regarding the amount of time per repetition. Decreased strength and endurance can be identified if the individual takes longer with each additional repetition.";
        data.measurementDescription =
          "Endurance or strength indicators can be determined by average difference between last and first stand repetition.";
        data.measurementsList = [
          "Individual takes significantly longer time with last repetition versus the first repetition of sitting to standing.",
          "Indicates decrease overall functional ability to perform ADLs as the individual fatigues during later repetitions.",
        ];
        break;

      case "NumbersOfSteps":
        data.description =
          "Cadence is the measure of the number of steps per minute, typically an increase in cadence is associated with a lower fall risk.";
        data.measurementDescription =
          "Measured in steps per minute against associated age brackets.";
        data.measurementsList = [
          "Indicates decrease motor control, strength, endurance, coordination as leg swing velocity is sharply decreased.",
          "High cadence but low gait speed indicates wide base of support or step width along with decreased step length.",
          "Decreased cadence can lead to increased fall risk as individual has less ability to perform a recovery step during a fall forward or sideways.",
        ];
        break;

      case "ShoulderAbduction":
        data = getAROMData("shoulder abduction in the frontal plane", [
          "Placing your hand behind your head requires ~120o.",
          "Combing hair requires ~120o.",
          "Lifting a shopping bag requires ~40o-50o.",
        ]);
        break;

      case "ShoulderFlexion":
        data = getAROMData("shoulder flexion in the sagittal plane", [
          "Donning and zipping pants ~79o.",
          "Completing pericare with ipsilateral limb ~65o.",
          "Reaching for box off shelf ~23o.",
        ]);
        break;

      // Add similar assignments for other cases
      case "ElbowFlexion":
        data = getAROMData("elbow flexion in the frontal plane", [
          "Using a cellphone ~140o-150o.",
          "Sit to stand ~100o-110o.",
          "Fastening button on pants ~70o.",
        ]);
        break;

      case "ElbowExtension":
        data = getAROMData("elbow extension in the frontal plane", [
          "Opening a door ~10o-20o.",
          "Sit to stand ~20o.",
          "Turning a page ~70o - 75o.",
        ]);
        break;

      case "OverallMobilityGait":
        data.description =
          "The individual is at a ##%^3 risk of fall in the next 12 months and is a #### mobility based on their performed gait speed. The individual performed at 3.7 standard deviations ^ 2(below / above) the mean gait speed for age range(## - ## /## +) and is in the ## percentile for this population.";
        break;

      case "TotalTimeTug":
        data.description =
          "Measured by total time to stand up out of a chair walk 10 feet turn and sit back down. Measures components of gait, dynamic movement and function. May indicate decreased strength, pain, range of motion or coordination dysfunction.";
        data.measurementDescription = "";
        data.measurementsList = [
          {
            main: "Community Ambulatory",
            sub: [
              "Test greater than 13.5 seconds positively rules IN a fall risk, but a test under 13.5 seconds does NOT rule out a fall.",
            ],
          },
          {
            main: "Frailty",
            sub: [
              "32 seconds for your frail residents- rules IN.",
              "A poor TUG score indicates decrease in the ability of individuals to perform common tasks during ADL activities.",
              "Test should be correlated to other subjective and objective examination testing.",
            ],
          },
        ];
        break;
      case "ForwardReach":
        data.description =
          "Measured in inches with arms at a starting position of 90 degrees of flexion followed by leaning forward and reaching to an end point.";
        data.measurementDescription = "";
        data.measurementsList = [
          {
            main: "Decreased distance indicates",
            sub: [
              "Decrease limits of stability and safety with reaching ADLs.",
              "Decrease strength in low back and hip extensors.",
              "Decrease hip stability for balance.",
            ],
          },
        ];
        break;
      case "LateralReach":
        data.description =
          "Measured in inches with arms at a starting position of 90 degrees of abduction followed by leaning forward and reaching to an end point.";
        data.measurementDescription = "";
        data.measurementsList = [
          "Normative values available.",
          "Not recorded into mobility score.",
          "Important to address asymmetries, as individuals are more at risk when they have a deficit on the same side as dominant arm.",
        ];
        break;
      case "Visual Score":
        data.description =
          "Data provides insight to assist in determining which of the sensory systems are being utilized to maintain balance.";
        data.measurementDescription =
          "Measured with ability to balance with eyes closed for 30 secs, which isolates the visual system.";
        data.measurementsList = [
          "Aging population begins to rely on vision more than the other systems",
          "Average sway/shift/velocity",
          "The visual system triggers neural signals to the brain based upon the relationship between the eyes/head to the horizon",
          "Poor vision score indicates increase + reliance on vision over the other system, and decreases safety at dawn/dusk",
          "Vision is strong and interventions should work on other systems with eyes closed",
        ];
        break;
      case "Vestibular Score":
        data.description =
          "Data provides insight to assist in determining which of the sensory systems are being utilized to maintain balance. ";
        data.measurementDescription =
          "Measured with ability to balance with eyes closed on foam pad for 30 secs, which isolates the vestibular system.";
        data.measurementsList = [
          "Average sway/shift/velocity.",
          "Vestibular system triggers neural signals to the brain based upon the relationship between the inner and gravitational pull.",
          "The relationship between fluid and small hair-like structures in your inner ear send neural signals to the brain based upon head position compared to gravity.",
          "Poor vestibular system score indicates decrease ability to understand where one is in space during static and dynamic movements.",
          "Individuals typically have head motion sensitive in static standing or dynamic walking activities.",
        ];
        break;
      case "Somatosensory Score":
        data.description =
          "Measured with ability to balance with eyes open on foam pad for 30 secs, which isolates the somatosensory system";
        data.measurementDescription =
          "Measured with ability to balance with eyes closed on foam pad for 30 secs, which isolates the vestibular system.";
        data.measurementsList = [
          "Average sway/shift/velocity.",
          "Somatosensory/proprioception is biofeedback from the ground through the feet to the ankles, knees, and hips relayed as sensory information to the brain.",
          "Poor somatosensory/proprioception score indicates low reaction of the body to ground reaction forces and + somatosensory problem.",
          "Uneven or soft surfaces are more difficult to walk on, in addition to transitioning to different surfaces.",
        ];
        break;

      default:
        data.unit = "unknown";
        data.description = "No description available for this graph.";
        data.measurementDescription = "No measurement description available.";
        data.measurementsList = [];
        break;
    }

    return data; // Return the populated modal data
  };

  return (
    <IonGrid className="" placeholder={undefined}>
      <IonModal
        className="graph-assessment-description-modal-wrap"
        backdropDismiss={false}
        placeholder={undefined}
        isOpen={GraphAsseDesc}
      >
        <GraphAssessmentDescriptionModal
          {...modalData}
        ></GraphAssessmentDescriptionModal>
      </IonModal>
      {/* <IonModal
        className="remove-paper-modal-wrap"
        backdropDismiss={false}
        isOpen={RemovePaper}
        placeholder={undefined}
      >
        <RemovePaperModal setRemovePaper={setRemovePaper}></RemovePaperModal>
      </IonModal> */}
      <IonRow className="row" placeholder={undefined}>
        <IonCol className="col-sec" placeholder={undefined}>
          <div
            className={`bar-chart-card ${options.graphName}`}
            style={{
              minHeight:
                options.graphTitle === "Average Speed" ||
                options.graphTitle === "Meters Lost" ||
                options.graphTitle === "Distance" ||
                options.graphTitle === "Red Lights Missed"
                  ? "350px"
                  : "330px",
            }}
          >
            <div>
              <div
                className="bar-chart-flex top-heading"
                style={{
                  minHeight:
                    options.graphTitle === "Average Speed" ||
                    options.graphTitle === "Meters Lost" ||
                    options.graphTitle === "Distance" ||
                    options.graphTitle === "Red Lights Missed"
                      ? "80px"
                      : "auto",
                }}
              >
                {options.graphName !== "Visual Score" &&
                  options.graphName !== "Vestibular Score" &&
                  options.graphName !== "Somatosensory Score" &&
                  options.graphName !== "Composite Score" &&
                  options.graphSVG}
                <div>
                  {options.graphTitle && (
                    <h6 className="bar-chart-label">
                      {options.graphTitle === "Average Speed" ? (
                        <>
                          Steps per Second during <br /> Green Lights
                        </>
                      ) : options.graphTitle === "Distance" ? (
                        <>
                          Total Steps <br />
                        </>
                      ) : options.graphTitle === "Meters Lost" ? (
                        "Number of Steps Lost"
                      ) : (
                        `${options.graphTitle} ${options.graphTitleDesc ?? ""}`
                      )}
                    </h6>
                  )}
                </div>

                {options.graphName != "FallRisk" &&
                  options.graphName != "TotalTime" &&
                  options.graphName != "AverageSpeed" &&
                  options.graphName != "Distance" &&
                  options.graphName != "RedLightsMissed" &&
                  options.graphName != "MetersLost" &&
                  options.graphName != "StepsLength" &&
                  options.graphName != "Composite Score" && (
                    <div
                      className="exclamation-icon-graph"
                      onClick={handleOpenModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M14.4486 11.9198C14.4486 11.1945 13.8606 10.6065 13.1353 10.6065C12.41 10.6065 11.822 11.1945 11.822 11.9198V17.9865C11.822 18.7118 12.41 19.2998 13.1353 19.2998C13.8606 19.2998 14.4486 18.7118 14.4486 17.9865V11.9198ZM13.0749 6.96648C12.3495 6.96648 11.7615 7.55448 11.7615 8.27982V8.40115C11.7615 9.12648 12.3495 9.71448 13.0749 9.71448H13.1962C13.9215 9.71448 14.5095 9.12648 14.5095 8.40115V8.27982C14.5095 7.55448 13.9215 6.96648 13.1962 6.96648H13.0749ZM13.1353 0.899817C6.379 0.899817 0.901953 6.37687 0.901953 13.1332C0.901953 19.8894 6.379 25.3665 13.1353 25.3665C19.8916 25.3665 25.3686 19.8894 25.3686 13.1332C25.3686 6.37687 19.8916 0.899817 13.1353 0.899817ZM3.52862 13.1332C3.52862 7.82753 7.82967 3.52648 13.1353 3.52648C18.4409 3.52648 22.742 7.82753 22.742 13.1332C22.742 18.4388 18.4409 22.7398 13.1353 22.7398C7.82967 22.7398 3.52862 18.4388 3.52862 13.1332Z"
                          fill="#31344E"
                          stroke="#31344E"
                          strokeWidth="0.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  )}
              </div>
              {options.graphName == "FallRisk" && (
                <div className="graph-top-sec">
                  <ul>
                    <li>Low</li>
                    <li>Med</li>
                    <li>High</li>
                  </ul>
                </div>
              )}
            </div>

            {options.graphName == "TimePerRep" && (
              <span className="reps">Reps</span>
            )}

            <div className="graph-main-sec-wrap">
              <div className="graph-main-sec-inner-wrap">
                {options.graphName == "GaitSpeed" && (
                  <div className="rl-data-wrap">
                    {options.graphActualValue.length > 0 &&
                      options.graphActualValue.map(
                        (actualValue: any, index) => {
                          return (
                            <>
                              <div
                                className={`rl-data ${
                                  dataOut(actualValue) ? "data-out" : ""
                                }`}
                                style={{
                                  width: checkNormWithAgeCssWidth() + "%",
                                  backgroundColor:
                                    getBackgroundBarColor(actualValue),
                                  height: `${
                                    50 / options.graphActualValue.length
                                  }px`,
                                }}
                              ></div>
                            </>
                          );
                        },
                      )}
                  </div>
                )}
                <div className="rl-data-wrap">
                  {options.graphActualValue.length > 0 &&
                    options.graphActualValue.map((actualValue: any, index) => {
                      return (
                        <>
                          <div
                            className={`rl-data ${
                              dataOut(actualValue) ? "data-out" : ""
                            }`}
                            style={{
                              width: getBarWidth(actualValue) + "%",
                              backgroundColor: getValueColor(actualValue),
                              height: `${
                                50 / options.graphActualValue.length
                              }px`,
                            }}
                          >
                            <strong>
                              {options.graphActualValueLabel[index]}
                            </strong>
                            {options.graphNoLines.length != 0}
                            <span>
                              {options?.graphNoLines[index]
                                ? options?.graphNoLines[index]
                                : ""}
                            </span>
                          </div>
                        </>
                      );
                    })}
                </div>
                {/* Normative line for Forward Reach */}
                {options.graphName === "ForwardReach" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getForwardReachNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getForwardReachNormValue(options.graphAge)}
                  </span>
                )}
                {/* Normative line for Lateral Reach */}
                {options.graphName === "LateralReach" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getLateralReachNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getLateralReachNormValue(options.graphAge)}
                  </span>
                )}
                {/* Normative line for Composite */}
                {options.graphName === "Composite Score" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getCompositeNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getCompositeNormValue(options.graphAge)}
                  </span>
                )}
                {options.graphName === "Visual Score" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getVisualNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getVisualNormValue(options.graphAge)}
                  </span>
                )}
                {/* Normative line for Vestibular */}
                {options.graphName === "Vestibular Score" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getVestibularNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getVestibularNormValue(options.graphAge)}
                  </span>
                )}
                {/* Normative line for Somatosensory */}
                {options.graphName === "Somatosensory Score" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getSomatosensoryNormValue(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getSomatosensoryNormValue(options.graphAge)}
                  </span>
                )}
                {/* Normative line for Total Time TUG */}
                {options.graphName === "TotalTimeTug" && (
                  <span
                    className="graph-dotted-lines"
                    style={{
                      left: `${getBarWidth(
                        getNormativeTime(options.graphAge),
                      )}%`,
                    }}
                  >
                    {getNormativeTime(options.graphAge)}
                  </span>
                )}
                {options.isgraphNorm && options.graphNormValue != null && (
                  <span
                    className="graph-dotted-lines"
                    style={{ left: checkNormWithAgeCssWidth() + "%" }}
                  >
                    {options.graphNormValue
                      ? options.graphNormValue
                      : checkNormWithAge()}
                  </span>
                )}
              </div>
              <div className="graph-data">
                {options.minMax && (
                  <span className="intial">
                    <strong>0%</strong>
                  </span>
                )}
                {options.graphRange.length > 0 &&
                  options.graphRange.map((level: any, index) => {
                    return (
                      <span
                        key={options.graphName + index.toString()}
                        className={`one ${options.minMax ? "fall-risk" : ""} `}
                        style={{
                          position: "absolute",
                          left: convertValueToPercentage(level) + "%",
                        }}
                      >
                        <strong>{options.graphRangeLabel[index]}</strong>
                      </span>
                    );
                  })}
                {options.minMax && (
                  <span className="last">
                    <strong>100%</strong>
                  </span>
                )}
              </div>
              {options.graphUnit !== "" && (
                <h4 className="graph-measurement">{options.graphUnit}</h4>
              )}
            </div>
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default CustomBarGraph;
